import { BasicComponent } from "haxt";

import "./JoinPage.scss";
import { GridSection } from "../components/sections/GridSection";

export class JoinPage extends BasicComponent<{
	page: string;
	parts: string[];
}> {

	/*
		GSI Full Membership with print copy of Irish Geography
		€50.00

		GSI Full Membership
		€40.00

		GSI Membership - Retired/Student/Unwaged with Print copy of Irish Geography
		€30.00

		GSI Membership - Retired/Student/Unwaged
		€20.00
	*/

	/*
Membership Type*
	Full Membership
	Full Membership (with print copy IG)
	Student
	Student (with print copy IG)
	Retired
	Retired (with print copy IG)
	Unwaged
	Unwaged (with print copy IG)
Title
	Prof
	Dr
	Mr
	Ms
Full Name *
	<input>
Professional Affiliation
	<input>
Email Address *
	<input>
Postal Address (please include if you are paying for a print copy of IG)
	<input>

	*/

	public render() {
		return (
			<GridSection class="JoinPage">
				<div class="box-full">
					<h1>Membership</h1>
					{/* <h1>Hello! We'd like to get to know you...</h1> */}
				</div>
				{/* <div class="box-form">
					<div class="form-input">
						<label for="membership-type">Membership Type*</label>
						<select id="membership-type" name="membership-type">
							<option value="full-membership">Full Membership (€40)</option>
							<option value="full-membership-print">Full Membership with print copy of Irish Geography (€50)</option>
							<option value="student">Student Membership (€20)</option>
							<option value="student-print">Student Membership with print copy of Irish Geography (€30)</option>
							<option value="retired">Retired Membership (€20)</option>
							<option value="retired-print">Retired Membership with print copy of Irish Geography (€30)</option>
							<option value="unwaged">Unwaged Membership (€20)</option>
							<option value="unwaged-print">Unwaged Membership with print copy of Irish Geography (€30)</option>
						</select>
					</div>

					<div class="form-input">
						<label for="title">Title</label>
						<select id="title" name="title">
							<option value="prof">Prof</option>
							<option value="dr">Dr</option>
							<option value="mr">Mr</option>
							<option value="ms">Ms</option>
						</select>
					</div>

					<div class="form-input">
						<label for="full-name">Full Name *</label>
						<input id="full-name" type="text" required />
					</div>

					<div class="form-input">
						<label for="affiliation">Professional Affiliation</label>
						<input id="affiliation" type="text" />
					</div>

					<div class="form-input">
						<label for="email">Email Address *</label>
						<input id="email" type="email" required />
					</div>

					<div class="form-input">
						<label for="postal-address">Postal Address (please include if you are paying for a print copy of IG)</label>
						<textarea id="postal-address"></textarea>
					</div>
				</div>
				<div class="box-full">
					<p>
						Current membership runs on a calendar year from January to December and brings a variety of benefits.
					</p>
					<p>
						The Society co-hosts and supports seminars, workshops, conferences and other events during the year,
						principally in Dublin, but also in other centres such as Limerick, Galway, Belfast and Cork.
					</p>
					<p>
						Other benefits include:
					</p>
					<ul>
						<li>A subscription to the international peer-reviewed journal Irish Geography </li>
						<li>Participation in field trips and events sponsored by the society</li>
						<li>Access to a network of individuals and organisations with similar interests.</li>
						<li>Information on geographical events in Ireland and overseas.</li>
					</ul>
				</div> */}
				{/* <div class="box-full">
					<p><strong>Full Membership -- Geographical Society of Ireland - €40.00</strong></p>
					<p>Full Membership of the Geographical Society of Ireland (GSI) is open to anyone with an interest in geography and related disciplines. Membership runs for 12 months from the date of sign-up and provides access to a vibrant national and international geographical community.</p>
					<p>Full Members receive annual online access to Irish Geography, the Society&#39;s peer-reviewed academic journal, featuring original research and critical perspectives on geographical issues in Ireland and beyond.</p>
					<p>Membership also includes a wide range of professional and community benefits, including:</p>
					<ul>
						<li>Participation in nationwide seminars, workshops, conferences, and fieldtrips</li>
						<li>Opportunities to attend co-hosted events with other national bodies</li>
						<li>Connection to a broad network of geographers across academia, education, policy, and practice</li>
						<li>Engagement with current debates, research, and initiatives shaping geography in Ireland</li>
						<li>Full Membership supports the work of the GSI while offering valuable opportunities for learning, networking, and professional development.</li>
					</ul>

					<p><strong>Concessionary Membership -- Geographical Society of Ireland - €20.00</strong></p>
					<p>Concessionary Membership of the Geographical Society of Ireland is available to students, the unwaged, and retired individuals. Membership runs for 12 months from the date of sign-up and offers the same core benefits as Full Membership at a reduced rate.</p>
					<p>Concessionary Members receive annual online access to Irish Geography, the Society&#39;s peer-reviewed journal, providing access to high-quality geographical research and scholarship.</p>
					<p>Membership benefits include:</p>
					<ul>
						<li>Access to nationwide seminars, workshops, conferences, and fieldtrips</li>
						<li>Attendance at co-hosted events with other national bodies</li>
						<li>Inclusion in a supportive network of geographers across Ireland and beyond</li>
						<li>Opportunities to engage with the geographical community regardless of career stage or employment status</li>
						<li>Concessionary Membership ensures that participation in the GSI remains accessible, inclusive, and supportive of lifelong engagement with geography.</li>
					</ul>
				</div> */}
				<div class="box-full">
					<p>
						Members receive annual online access to Irish Geography, the Society's peer-reviewed academic journal,
						featuring original research and critical perspectives on geographical issues in Ireland and beyond.
						Membership also includes a wide range of professional and community benefits, including:
					</p>
					<ul>
						<li>Participation in nationwide seminars, workshops, conferences, and fieldtrips;</li>
						<li>Opportunities to attend co-hosted events with other national bodies;</li>
						<li>Connection to a broad network of geographers across academia, education, policy, and practice;</li>
						<li>Engagement with current debates, research, and initiatives shaping geography in Ireland;</li>
						<li>Full Membership supports the work of the GSI while offering valuable opportunities for learning, networking, and professional development.</li>
					</ul>
					<p>
						Membership runs for a calendar year from January - December.
					</p>
				</div>
				{/* 
				<div class="box">
					<h3>Full Membership</h3>
					<h4>Geographical Society of Ireland</h4>
					<p>Full Membership of the Geographical Society of Ireland (GSI) is open to anyone with an interest in geography and related disciplines. Membership runs for 12 months from the date of sign-up and provides access to a vibrant national and international geographical community.</p>
					<p>Full Members receive annual online access to Irish Geography, the Society&#39;s peer-reviewed academic journal, featuring original research and critical perspectives on geographical issues in Ireland and beyond.</p>
					<p>Membership also includes a wide range of professional and community benefits, including:</p>
					<ul>
						<li>Participation in nationwide seminars, workshops, conferences, and fieldtrips</li>
						<li>Opportunities to attend co-hosted events with other national bodies</li>
						<li>Connection to a broad network of geographers across academia, education, policy, and practice</li>
						<li>Engagement with current debates, research, and initiatives shaping geography in Ireland</li>
						<li>Full Membership supports the work of the GSI while offering valuable opportunities for learning, networking, and professional development.</li>
					</ul>
					<p>€40.00 per year</p>
					<button>Subscribe</button>
				</div>
				<div class="box">
					<h3>Concessionary Membership</h3>
					<h4>Geographical Society of Ireland</h4>
					<p>Concessionary Membership of the Geographical Society of Ireland is available to students, the unwaged, and retired individuals. Membership runs for 12 months from the date of sign-up and offers the same core benefits as Full Membership at a reduced rate.</p>
					<p>Concessionary Members receive annual online access to Irish Geography, the Society&#39;s peer-reviewed journal, providing access to high-quality geographical research and scholarship.</p>
					<p>Membership benefits include:</p>
					<ul>
						<li>Access to nationwide seminars, workshops, conferences, and fieldtrips</li>
						<li>Attendance at co-hosted events with other national bodies</li>
						<li>Inclusion in a supportive network of geographers across Ireland and beyond</li>
						<li>Opportunities to engage with the geographical community regardless of career stage or employment status</li>
						<li>Concessionary Membership ensures that participation in the GSI remains accessible, inclusive, and supportive of lifelong engagement with geography.</li>
					</ul>
					<p>€20.00 per year</p>
					<button>Subscribe</button>
				</div>
				*/}
				{/* 
				
Reduce text down to only two buttons: 

Full Membership - please select this option if you are in full time employment 
Concessionary Membership - please select this option if you are a student, unwaged or retired.

Below these include the following text: Please note membership runs on a calendar year, from January - December.
Both of the above options include access to the same level of membership benefits.
				
				*/}
				<div class="box">
					<h4>Full Membership</h4>
					<p>Please select this option if you are in full time employment</p>
					<p>€40.00 per year</p>
					<button>Login to subscribe</button>
				</div>
				<div class="box">
					<h3>Concessionary Membership</h3>
					<p>Please select this option if you are a student, unwaged or retired.</p>
					<p>€20.00 per year</p>
					<button>Login to subscribe</button>
				</div>
				<div class="box-full">
					<h4>
						Please note membership runs on a calendar year, from January - December.
						Both of the above options include access to the same level of membership benefits.
					</h4>
				</div>
				{/* <div class="box">
					<h3>GSI Full Membership with print copy of Irish Geography</h3>
					<p>€50.00</p>
					<button>Shop</button>
				</div>
				<div class="box">
					<h3>GSI Full Membership</h3>
					<p>€40.00</p>
					<button>Shop</button>
				</div>
				<div class="box">
					<h3>GSI Membership - Retired/Student/Unwaged with Print copy of Irish Geography</h3>
					<p>€30.00</p>
					<button>Shop</button>
				</div>
				<div class="box">
					<h3>GSI Membership - Retired/Student/Unwaged</h3>
					<p>€20.00</p>
					<button>Shop</button>
				</div> */}
			</GridSection>
		);
	}
}
